import { present } from 'shared/presenters/presenter'
import { Materialized_Bookability_By_Days } from 'shared/presenters/graphqlTypes'

export class MaterializedBookabilityPresenter extends present<Materialized_Bookability_By_Days>() {}
